module.exports = __webpack_public_path__ + "static/Huomentaa-Suomi-1cc1c7fd4466e3afc9c389fd6a23f6e0.png";